/**
 * Stable CSS class names for E2E — RuleServiceV2 RuleTemplate tab.
 */
export const RTT = {
    root: 'rule-template-tab',
    createButton: 'rule-template-tab-input--button-create',
    gridSection: 'rule-template-tab__grid-section',
    modalSection: 'rule-template-tab__modal-section',
} as const;

export const rttCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

